module.exports = __webpack_public_path__ + "img/excel.960d0a07.svg";